import request from '@/utils/request'

export function fetchBodyTypeList() {
    return request({
        url: `/api/body-type/index`,
        method: 'get',
    })
}

